import Api from "data/repository/Api";

export const getCountries = async () => {
    const res = await Api().get(`/countries`);
    return res.data["hydra:member"];
};